import { cn } from '@/lib/utils';

/** Símbolo geométrico: losango de expansão formado por nós conectados (rede nacional). */
export const LogoMark = ({ className }) => (
  <svg viewBox="0 0 40 40" className={cn('h-8 w-8', className)} aria-hidden="true">
    <defs>
      <linearGradient id="lm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#67e8f9" />
        <stop offset="100%" stopColor="#3b82f6" />
      </linearGradient>
    </defs>
    <rect x="1" y="1" width="38" height="38" rx="10" fill="#0b1018" stroke="rgba(255,255,255,0.10)" />
    <path d="M20 7 L33 20 L20 33 L7 20 Z" fill="none" stroke="url(#lm-g)" strokeWidth="1.6" />
    <path d="M20 7 L20 33 M7 20 L33 20" stroke="rgba(103,232,249,0.35)" strokeWidth="1" />
    <path d="M13.5 26.5 L20 20 L28 12" fill="none" stroke="#22d3ee" strokeWidth="2" strokeLinecap="round" />
    <circle cx="28" cy="12" r="2.4" fill="#ff3b5c" />
    <circle cx="20" cy="20" r="2.2" fill="#e0fbff" />
    <circle cx="13.5" cy="26.5" r="1.8" fill="#22d3ee" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    {!compact && (
      <span className="flex flex-col leading-none">
        <span className="font-display text-[15px] font-semibold tracking-tight text-foreground">
          Brasil Livre <span className="text-primary">Business</span>
        </span>
        <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.22em] text-muted-foreground">Rede nacional de negócios</span>
      </span>
    )}
  </span>
);
